import { GetterTree } from 'vuex/types/index'
import { RootState } from '~/store/store.types'
import { getResource } from '~/utils/store'
import { Product, ProductsState, ProductResource } from './products.types'

const getters: GetterTree<ProductsState, RootState> = {
  products (state, getters, rootState, rootGetters): Product[] {
    return Object.values(state.data).map(({ id }) => getResource<ProductResource>(state, id, rootGetters, 'venue'))
  },

  productById (state, getters, rootState, rootGetters) {
    return (productId: string) => getResource<ProductResource>(state, productId, rootGetters, 'venue')
  }
}

export default getters
